import { Directive, Input, } from '@angular/core';
import { isAbsoluteUrl } from '@sitecore-jss/sitecore-jss/utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class RichTextDirective {
    viewContainer;
    templateRef;
    renderer;
    router;
    editable = true;
    field;
    viewRef;
    constructor(viewContainer, templateRef, renderer, router) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
        this.renderer = renderer;
        this.router = router;
    }
    ngOnChanges(changes) {
        if (changes.field || changes.editable) {
            if (!this.viewRef) {
                this.viewContainer.clear();
                this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
            }
            this.updateView();
        }
    }
    updateView() {
        const field = this.field;
        if (!field || (!field.editable && !field.value)) {
            return;
        }
        const html = field.editable && this.editable ? field.editable : field.value;
        this.viewRef.rootNodes.forEach((node) => {
            node.innerHTML = html;
            if (!node.querySelectorAll) {
                return;
            }
            const links = node.querySelectorAll('a[href]');
            const linksArray = [].slice.call(links);
            linksArray.forEach((link) => {
                const href = link.getAttribute('href');
                const target = link.getAttribute('target');
                if (!href || isAbsoluteUrl(href) || target === '_blank' || target === '_top') {
                    return;
                }
                this.renderer.listen(link, 'click', (event) => {
                    this.router.navigateByUrl(href);
                    event.preventDefault();
                });
            });
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RichTextDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }, { token: i0.Renderer2 }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: RichTextDirective, selector: "[scRichText]", inputs: { editable: ["scRichTextEditable", "editable"], field: ["scRichText", "field"] }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RichTextDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[scRichText]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }, { type: i0.Renderer2 }, { type: i1.Router }]; }, propDecorators: { editable: [{
                type: Input,
                args: ['scRichTextEditable']
            }], field: [{
                type: Input,
                args: ['scRichText']
            }] } });
